export { default } from './ProjectsTilesView';
